import { SellerDetails } from '@/types/SellerDetails';

export type SellerDetailsSlice = {
    byId: { [sellerId: number]: SellerDetails };
    loaded: { [sellerId: number]: number };
    loading: number[];
};

export const defaultSellerDetailsSlice: SellerDetailsSlice = {
    byId: {},
    loaded: {},
    loading: [],
};
